import { defineNuxtPlugin } from "#app";

export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.directive("draggable-scroll", {
    mounted(el: HTMLElement) {
      let isDown = false;
      let posX: number;
      let velocity = 0;
      let lastMoveTime = 0;
      let rafId: number | null = null;

      const handleMouseDown = (e: MouseEvent) => {
        isDown = true;
        posX = e.screenX;
        lastMoveTime = Date.now();
        cancelInertia();
      };

      const handleMouseLeave = () => {
        if (isDown) handleMouseUp(); // 마우스가 엘리먼트를 벗어나도 관성 적용
      };

      const handleMouseUp = () => {
        isDown = false;
        applyInertia();
      };

      const handleMouseMove = (e: MouseEvent) => {
        if (!isDown) return;
        e.preventDefault();

        const deltaX = e.screenX - posX;
        posX = e.screenX;

        const now = Date.now();
        const deltaTime = now - lastMoveTime;
        lastMoveTime = now;

        // 너무 큰 deltaX가 적용되지 않도록 제한
        if (Math.abs(deltaX) > 100) return;

        velocity = deltaX / deltaTime;
        el.scrollLeft -= deltaX;
      };

      const applyInertia = () => {
        if (Math.abs(velocity) < 0.01) {
          cancelInertia();
          return;
        }
        el.scrollLeft -= velocity * 20; // 속도에 따라 이동량 조절
        velocity *= 0.95; // 감속 비율
        rafId = requestAnimationFrame(applyInertia);
      };

      const cancelInertia = () => {
        if (rafId) {
          cancelAnimationFrame(rafId);
          rafId = null;
        }
      };

      el.addEventListener("mousedown", handleMouseDown);
      el.addEventListener("mouseleave", handleMouseLeave);
      el.addEventListener("mouseup", handleMouseUp);
      el.addEventListener("mousemove", handleMouseMove);

      (el as any)._cleanup = () => {
        el.removeEventListener("mousedown", handleMouseDown);
        el.removeEventListener("mouseleave", handleMouseLeave);
        el.removeEventListener("mouseup", handleMouseUp);
        el.removeEventListener("mousemove", handleMouseMove);
        cancelInertia();
      };
    },
    unmounted(el: HTMLElement) {
      (el as any)._cleanup();
    },
  });
});
